import { Banner as BannerBase } from './Banner';
import { BannerAction } from './BannerAction';
import { BannerDescription } from './BannerDescription';
import { BannerDismiss } from './BannerDismiss';
import { BannerIcon } from './BannerIcon';
import { BannerPane } from './BannerPane';
import { BannerRoot } from './BannerRoot';
import { BannerTitle } from './BannerTitle';

const Banner = BannerBase as typeof BannerBase & {
  Action: typeof BannerAction;
  Description: typeof BannerDescription;
  Dismiss: typeof BannerDismiss;
  Icon: typeof BannerIcon;
  Pane: typeof BannerPane;
  Root: typeof BannerRoot;
  Title: typeof BannerTitle;
};
Banner.Action = BannerAction;
Banner.Description = BannerDescription;
Banner.Dismiss = BannerDismiss;
Banner.Icon = BannerIcon;
Banner.Pane = BannerPane;
Banner.Root = BannerRoot;
Banner.Title = BannerTitle;

export { Banner, BannerBase as BannerWithoutStatics };
